import { render, staticRenderFns } from "./chips.vue?vue&type=template&id=fe1892ba&scoped=true&"
import script from "./chips.vue?vue&type=script&lang=ts&"
export * from "./chips.vue?vue&type=script&lang=ts&"
import style0 from "./chips.vue?vue&type=style&index=0&id=fe1892ba&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1892ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
